module.exports = __webpack_public_path__ + "static/img/image (1).17bcb292.png";